import { render, staticRenderFns } from "./DeregistrationData.vue?vue&type=template&id=53863639&"
import script from "./DeregistrationData.vue?vue&type=script&lang=js&"
export * from "./DeregistrationData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports